import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchVideoTemplate } from "../actions/index";

import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import axios from 'axios';
import { CSSTransitionGroup } from 'react-transition-group';

class VideoPlayback extends Component {
  constructor(props) {
    super(props);
    this.state = { conversionComplete: this.props.conversion_complete, conversionCompleteCheckCount: 0 };
    this.videoJsOptions = {
      controls: true,
      height: 440,
      fluid: false
    };
  }

  componentDidMount() {
    this.checkConversionComplete();
  }

  checkConversionComplete() {
    if (this.state.conversionComplete == false) {
      this.props
        .fetchVideoTemplate(
          this.props.match.params.id
        )
        .then((result) => {
          let conversionComplete = result.payload.data.data.conversion_complete;
          if (conversionComplete == true) {
            this.setState({ conversionComplete: true });
          } else {
            if (this.state.conversionCompleteCheckCount < 100) {
              this.setState({ conversionCompleteCheckCount: this.state.conversionCompleteCheckCount + 1 });
              setTimeout(() => {
                this.checkConversionComplete();
              }, 3000);
            }
          }
        });
    }
  }

  render() {
    if ( this.state.conversionComplete == false ) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={1000}
        >
          <div className="panel panel-default video_playback_spinner">
            <div className="panel-body">
              <div class="row spinner">
                <div class="text-center col-md-12">
                  <i className="fa fa-refresh fa-4x fa-spin" />
                </div>
              </div>
              <div class="row spinner_text">
                <div class="text-center col-md-12">
                  Please wait while the video is being converted . . .
                </div>
              </div>
            </div>
          </div>
        </CSSTransitionGroup>
      );
    } else {
      return (
          <video
              id="PlayVideo"
              className="video-js vjs-default-skin"
              controls
              data-setup='{}'>
            <source src={this.props.s3_url} type="video/mp4"></source>
            <p className="vjs-no-js">
              To listen to this audio please enable JavaScript, and consider upgrading to a
              web browser that
              <a
                href="https://videojs.com/html5-video-support/"
                target="_blank"
                rel="noreferrer"
              >
                supports HTML5 audio
              </a>
            </p>
          </video>
      );
    }
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { fetchVideoTemplate }
)(VideoPlayback);
